import React from "react";

const Dashboard = (props) => {
  return (
    <div></div>
  );
}

export default Dashboard;
